import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import koinWordmark from '../../assets/koin_text_only_logo.png';

const links = [
  { label: 'Terms of Service', href: '/terms' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Disclaimer', href: '/disclaimer' },
  { label: 'Contact Us', href: '/contact' }
];

const socials = [
  { label: 'LinkedIn', icon: <LinkedInIcon fontSize="small" /> },
  { label: 'X', icon: <XIcon fontSize="small" /> },
  { label: 'Instagram', icon: <InstagramIcon fontSize="small" /> }
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ borderTop: '1px solid #F3F4F6', pt: { xs: 5, md: 7 }, pb: { xs: 12, md: 5 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { md: 'flex-start' },
            gap: { xs: 4, md: 6 }
          }}
        >
          <Box>
            <Box
              component="a"
              href="/"
              aria-label="KOIN home"
              sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, borderRadius: '8px', '&:focus-visible': { outline: '3px solid #F57C00', outlineOffset: 4 } }}
            >
              <Box component="img" src="/koin_logo_yellow.png" alt="" sx={{ height: 40, width: 'auto' }} />
              <Box component="img" src={koinWordmark} alt="" sx={{ height: 28, width: 'auto' }} />
            </Box>
            <Typography sx={{ mt: 1.5, color: '#4B5563', fontSize: '0.95rem', maxWidth: '30ch' }}>
              Earn rewards daily for simple app tasks.
            </Typography>
          </Box>

          <Box
            component="nav"
            aria-label="Footer"
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, auto)' },
              columnGap: { xs: 2, md: 4 },
              rowGap: 1.5
            }}
          >
            {links.map((l) => (
              <Link
                key={l.href}
                href={l.href}
                underline="none"
                sx={{ color: '#374151', fontSize: '0.95rem', fontWeight: 500, '&:hover': { color: '#C2410C' } }}
              >
                {l.label}
              </Link>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            mt: { xs: 4, md: 6 },
            pt: 3,
            borderTop: '1px solid #F3F4F6',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Typography sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
            © {new Date().getFullYear()} Koin
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {socials.map((s) => (
              <IconButton
                key={s.label}
                href="#"
                aria-label={s.label}
                sx={{ width: 40, height: 40, color: '#374151', border: '1px solid #E5E7EB', '&:hover': { color: '#C2410C', borderColor: '#FFB300', bgcolor: '#FFF8EC' } }}
              >
                {s.icon}
              </IconButton>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
